import React from "react";
import { Box, Typography, makeStyles, Breadcrumbs, Link } from "@material-ui/core";
import vaultHeroImg from "../../../Main/Landing/images/Vault/hero_img.png";

const useStyles = makeStyles((theme) => ({
    heroSection: {
        position: 'relative',
        padding: '0px 5% 0',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        minHeight: '360px',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
        [theme.breakpoints.down('sm')]: {
            minHeight: 'auto',
            padding: '0px 5% 0',
        }
    },
    heroContent: {
        maxWidth: 1314,
        width: '100%',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse',
            textAlign: 'center',
            gap: '40px',
        }
    },
    heroTextContainer: {
        flex: 1,
        maxWidth: '805px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingBottom: '60px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            alignItems: 'center',
            paddingBottom: '40px',
        },
    },
    heroTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '64px',
        fontWeight: 400,
        lineHeight: '100%',
        marginBottom: '24px',
        color: '#ffffff',
        [theme.breakpoints.down('sm')]: {
            fontSize: '44px',
            lineHeight: '56px',
            marginTop: "36px",
            marginBottom: '20px',
        }
    },
    heroSubtitle: {
        fontSize: '18px',
        fontWeight: 200,
        color: '#ffffff',
        lineHeight: '27px',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px',
        }
    },
    breadcrumbNav: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#ffffff',
        fontSize: '16px',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        '& a': {
            color: '#ffffff',
            textDecoration: 'none',
        }
    },
    activeBreadcrumb: {
        color: '#fe5a97',
        fontWeight: 500,
    },
    heroImageContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        paddingBottom: 0,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },
    heroImage: {
        width: '100%',
        maxWidth: '500px',
        objectFit: 'contain',
        display: 'block',
        verticalAlign: 'bottom',
    }
}));

export const VaultHeroSection: React.FC = () => {
    const classes = useStyles();

    return (
        <Box className={classes.heroSection}>
            <Box className={classes.heroContent}>
                <Box className={classes.heroTextContainer}>
                    <Typography variant="h1" className={classes.heroTitle}>
                        Unlock The Vault
                    </Typography>
                    <Typography className={classes.heroSubtitle}>
                        Discover the elite benefits of being part of SugarCribs - from exclusive access and complete discretion to creator control and premium experiences, The Vault represents the core values of our platform.
                    </Typography>

                    <Box className={classes.breadcrumbNav}>
                        <Link href="/">Home</Link>
                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L5 5L1 9" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className={classes.activeBreadcrumb}>The Vault</span>
                    </Box>
                </Box>
                <Box className={classes.heroImageContainer}>
                    <img src={vaultHeroImg} alt="Unlock The Vault" className={classes.heroImage} />
                </Box>
            </Box>
        </Box>
    );
};
